import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate, Flex, Checkbox, Button, ButtonGroup } from '@haldor/ui';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { getServices, sendAdminInvitation, getConsentInfo, getAdminInvitations } from '../../actions/services';
import { Spinner } from 'UI';
import getEnvironment from 'lib/env';
import './_onboarding.scss';
import SelectConsentWay from './Step2/SelectConsentWay';
import VerdictFeedbackForm from 'containers/Verdict/Form/Partials/VerdictFeedbackForm';
import EmailAdminInvite from './Step2/EmailAdminInvite';
import EmailAdminSent from './Step2/EmailAdminSent';
import WaitingForResponse from './Step2/WaitingForResponse';
import { appInsights } from 'lib/appInsights';

var ConsentManager = /*#__PURE__*/function (_Component) {
  _inherits(ConsentManager, _Component);

  var _super = _createSuper(ConsentManager);

  function ConsentManager(props) {
    var _this;

    _classCallCheck(this, ConsentManager);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "goBack", function () {
      return new Promise(function (resolve) {
        if (_this.props.onSubmit) {
          _this.props.onSubmit(0).then(function () {
            resolve(1);
          });
        }
      });
    });

    _this.state = {
      isLoading: true,
      showEmailInfo: false,
      showConsentInfo: true,
      showEmailSentInfo: false,
      showWaitingResponse: false,
      waitingResponse: false,
      adminEmail: null,
      recpients: [],
      inviteRetry: 0,
      user: {
        name: '',
        email: ''
      }
    };
    return _this;
  }

  _createClass(ConsentManager, [{
    key: "inIframe",
    value: function inIframe() {
      try {
        return window.self !== window.top || window.navigator.userAgent.indexOf('TeamsMobile') > -1;
      } catch (e) {
        return true;
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      appInsights.trackTrace({
        message: "Onboarding | ConsentManager was initiated"
      });
      this.props.getAdminInvitations().then(function () {
        if (_this2.props.adminInvitations != null) {
          if (_this2.props.adminInvitations.sentByMe) {
            _this2.showPage('waitingForResponse');
          }
        }

        _this2.setState({
          isLoading: false
        });
      });
    }
  }, {
    key: "showPage",
    value: function showPage(pageName) {
      switch (pageName) {
        case 'showEmailInfo':
          this.setState({
            showEmailSentInfo: false,
            showConsentInfo: false,
            showEmailInfo: true,
            showWaitingResponse: false
          });
          break;

        case 'showConsentInfo':
          if (this.props.adminInvitations != null) {
            if (this.props.adminInvitations.sentByMe) {
              this.showPage('waitingForResponse');
            } else {
              this.setState({
                showEmailSentInfo: false,
                showConsentInfo: true,
                showEmailInfo: false,
                showWaitingResponse: false
              });
            }
          } else {
            this.setState({
              showEmailSentInfo: false,
              showConsentInfo: true,
              showEmailInfo: false,
              showWaitingResponse: false
            });
          }

          break;

        case 'showEmailSentInfo':
          this.setState({
            showEmailSentInfo: true,
            showConsentInfo: false,
            showEmailInfo: false,
            showWaitingResponse: false
          });
          break;

        case 'navigateToAdminConsent':
          if (this.props.onSubmit) {
            this.props.onSubmit(2);
          }

          break;

        case 'waitingForResponse':
          this.setState({
            showEmailSentInfo: false,
            showConsentInfo: false,
            showEmailInfo: false,
            showWaitingResponse: true
          });

        default:
          //this.setState({ showEmailSentInfo: false, showConsentInfo: true, showEmailInfo: false, showWaitingResponse: false });
          break;
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, this.state.isLoading ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : /*#__PURE__*/React.createElement("div", null, this.state.showConsentInfo ? /*#__PURE__*/React.createElement(SelectConsentWay, {
        showPage: this.showPage.bind(this),
        goBack: this.goBack.bind(this)
      }) : null, this.state.showEmailInfo ? /*#__PURE__*/React.createElement(EmailAdminInvite, {
        showPage: this.showPage.bind(this)
      }) : null, this.state.showEmailSentInfo ? /*#__PURE__*/React.createElement(EmailAdminSent, {
        showPage: this.showPage.bind(this)
      }) : null, this.state.showWaitingResponse ? /*#__PURE__*/React.createElement(WaitingForResponse, {
        showPage: this.showPage.bind(this),
        goBack: this.goBack.bind(this)
      }) : null));
    }
  }]);

  return ConsentManager;
}(Component);

_defineProperty(ConsentManager, "contextTypes", {
  router: PropTypes.object
});

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    currentUser: state.user.currentUser,
    selectedServices: state.Services.selectedServices,
    consentInfo: state.Services.consentInfo,
    inviteAdminStatus: state.Services.inviteAdminStatus,
    onboardingUser: state.user.onboardingUser,
    adminInvitations: state.Services.adminInvitations
  };
}

export default connect(mapStateToProps, {
  getServices: getServices,
  sendAdminInvitation: sendAdminInvitation,
  getConsentInfo: getConsentInfo,
  getAdminInvitations: getAdminInvitations
})(reduxForm({
  form: 'AdminInvite',
  destroyOnUnmount: true
})(ConsentManager));